module.exports = __webpack_public_path__ + "0e436fbc07899ad5634cd78344e2d4fd.png";